import { useParams, useNavigate } from 'react-router-dom';
import moment from "moment";
import useApi from "../../../utility/Hooks/Api/useApi";
import React, { useEffect, useState } from "react";
import RemarkTextArea from "../../../components/Inputs/Remark/RemarkTextArea";
import { VehicleApi } from '../../../services/Api/VehicleApi';
import { CompanyApi } from '../../../services/Api/CompanyApi';
import { UsersApi } from '../../../services/Api/UsersApi';
import { PartSpecificationsApi } from '../../../services/Api/PartSpecificationsApi';
import { ElectronicHousingUnitApi } from '../../../services/Api/ElectronicHousingUnitApi';
import CustomSelect from "../../../components/Selects/Custom/CustomSelect";
import { IdentificationIcon, MinusSmallIcon, PlusSmallIcon, PencilSquareIcon, SquaresPlusIcon } from "@heroicons/react/24/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faFloppyDisk, faRectangleXmark } from "@fortawesome/free-solid-svg-icons";
import { MinusCircleIcon } from "@heroicons/react/24/outline";
import ElectronicHousingUnitSelect from "../../../components/Selects/ElectronicHousingUnit/ElectronicHousingUnitSelect";
import PartsSelect from '../../../components/Selects/Parts/PartsSelect';

export default function VehicleDetailView() {
    const navigate = useNavigate();
    const { vehicleId: id } = useParams();
    const { request: vehicleRequest, data: vehicleData, loading: vehicleLoading } = useApi();
    const { request: vehiclesRequest, data: vehiclesData } = useApi();
    const { request: vehicleEhuRequest, data: vehicleEhuData, set: vehicleSetEhuData, loading: vehicleEhuLoading } = useApi();
    const { request: vehiclePartsRequest, data: vehiclePartsData, set: setVehiclePartsData, loading: vehiclePartsLoading } = useApi();
    const { request: vehicleRemarkRequest, data: vehicleRemarkData, loading: vehicleRemarkLoading } = useApi();
    const { request: companyRequest, data: companyData, loading: companyLoading } = useApi();
    const { request: specRequest, data: specData, loading: specLoading } = useApi();
    const { request: linkRequest, data: linkData, loading: linkLoading } = useApi();
    const { request: accountRequest, data: accountData, loading: accountLoading } = useApi();

    const [newRemark, setNewRemark] = useState("");
    const [editRemark, setEditRemark] = useState({ id: null, text: "" });
    const [showSelect, setShowSelect] = useState(false);
    const [showSelect2, setShowSelect2] = useState(false);
    const [editableVehicleData, setEditableVehicleData] = useState({});
    const [editing, setEditing] = useState({
        show: false,
    });
    const [loading, setLoading] = useState(true)
    const [partError, setPartError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await accountRequest(UsersApi.CurrentUser())
                await vehicleRequest(VehicleApi.getVehicle(id));
                await vehicleEhuRequest(VehicleApi.getVehicleEhu(id));
                await vehiclePartsRequest(VehicleApi.getVehicleParts(id));
                await companyRequest(CompanyApi.getCompanies());
                await specRequest(PartSpecificationsApi.getPartSpecifications())

            } catch (error) {

            }
        };

        fetchData();
    }, [id]);

    useEffect(() => {
        setEditableVehicleData(vehicleData)
    }, [vehicleData])

    useEffect(() => {
        const fetchDadata = async () => {
            if (companyData) {
                const id = getCompanyId(getCaseInsensitive(vehicleData, "owner"));
                try {
                    await vehiclesRequest(CompanyApi.getVehicles(id));
                } catch (error) {

                } finally {
                    setLoading(false);
                }
            }
        };

        fetchDadata()
    }, [vehicleData, companyData])

    const getCaseInsensitive = (obj, key) => {
        if (!obj) return undefined;
        const lowerCaseKey = key.toLowerCase();
        return Object.keys(obj).reduce((result, currentKey) => {
            return currentKey.toLowerCase() === lowerCaseKey ? obj[currentKey] : result;
        }, undefined);
    };

    const newRemarkHandler = (e) => {
        if (editRemark.id) {
            setEditRemark({ ...editRemark, text: e.target.value })
        } else {
            setNewRemark(e.target.value)
        }
    };

    const newRemarkRequestHandler = async (e) => {

        if (editRemark.id && editRemark.text !== "") {
            const obj = {
                "id": editRemark.id,
                "remark": editRemark.text.toString()
            };

            try {
                await vehicleRemarkRequest(VehicleApi.editRemark(obj.id, obj.remark));
                await vehicleRequest(VehicleApi.getVehicle(id));
                setEditRemark({ id: null, text: "" })
            } catch (error) {

            }

        } else {
            if (newRemark !== "") {
                const obj = {
                    "remark": newRemark.toString()
                };
                try {
                    await vehicleRequest(VehicleApi.remarkVehicle(id, obj));
                } catch (error) {

                }
                setNewRemark("")
            }
        }
    };

    const newRemarkCancelHandler = (e) => {
        if (editRemark.id) {
            setEditRemark({ id: null, text: "" })
        } else {
            setNewRemark("")
        }
    };

    const reverseArray = (arr) => {
        return arr.slice().reverse()
    };

    const addEhu = async (e) => {
        const ehu = JSON.parse(e.value)
        try {
            await linkRequest(VehicleApi.addEhu(id, ehu.id));
            await linkRequest(ElectronicHousingUnitApi.addVehicle(ehu.id, id));
        } catch (error) {

        }

        vehicleEhuData.push(ehu);
        setShowSelect(false)
    };

    const addPart = async (e) => {
        const part = JSON.parse(e.value);
        const serialNumber = part.serialNumber
        const type = part.specification.PartType
        try {
            await linkRequest(VehicleApi.addPart(id, part.id));
            vehiclePartsData.push(part);
            if (partError) { setPartError(null) }
        } catch (error) {
            if (error?.response?.data.includes("already has a connected vehicle")) {
                setPartError({ serialNumber, type, partId: part.id });
            }
        } finally {
            setShowSelect2(false)
        }
    };

    const removePart = async (partId) => {
        try {
            await linkRequest(VehicleApi.removePart(id, partId));
        } catch (error) {

        }

        const newArr = vehiclePartsData.filter(part => {
            return part.id !== partId;
        });
        setVehiclePartsData([...newArr]);
    };

    const removeEhu = async (ehuId) => {
        try {
            await linkRequest(VehicleApi.removeEhu(id, ehuId));
            await linkRequest(ElectronicHousingUnitApi.removeVehicle(ehuId, id));
        } catch (error) {

        }

        const newArr = vehicleEhuData.filter(ehu => {
            return ehu.id !== ehuId;
        });
        vehicleSetEhuData([...newArr]);
    };

    // Handle input change
    const handleInputChange = (field, value) => {
        setEditableVehicleData(prevState => ({
            ...prevState,
            [field]: value,
        }));
    };

    // Function to toggle editing state
    const toggleEditing = (field) => {
        setEditing(prevState => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };

    const dataUpdateRequestHandler = async (e) => {
        const { id, ...dataToSend } = e;
        try {
            vehicleRequest(VehicleApi.updateVehicle(id, dataToSend));
        } catch (error) {

        }

    }

    const companyOptions = () => {
        return companyData.map((company) => ({ value: company.id, label: company["company name"] }));
    };

    const getCompanyNameById = (companyId) => {
        return companyData?.find(company => company.id === companyId)?.["company name"] || "Unknown Company";
    };

    function getCompanyByCustomerId(companyData, id) {
        // Find the object with the matching "customer id"
        const customer = companyData.find(
            item =>
                String(item["customer id"]) === String(id) ||
                String(item["id"]) === String(id)
        );

        // If the object is found, return the "customer name"; otherwise, return null
        return customer ? customer["company name"] : null;
    };

    const getCompanyId = (id) => {
        // Find the customer based on "customer id" or "id"
        const customer = companyData.find(
            item =>
                String(item["customer id"]) === String(id) ||
                String(item["id"]) === String(id)
        );

        // Return the customer "id" if found, otherwise return null
        return customer ? customer["id"] : null;
    };

    const handleRemarkDelete = async (remarkId) => {
        try {
            await vehicleRemarkRequest(VehicleApi.deleteRemark(remarkId));
            await vehicleRequest(VehicleApi.getVehicle(id));
        } catch (error) {

        }

    }

    const handleRemarkEdit = async (id, text) => {
        setEditRemark({ id, text });
    }
    console.log(editRemark);

    const EditableField = ({ label, value, isEditing, onEdit, options, onSave, type = "text", backgroundColor, field, route }) => {

        const handleClick = () => {
            if (route) navigate(`${route}`);
        };
        return (
            <div className={`flex py-2 border-t border-blue-100 px-4 text-sm ${backgroundColor}`}>
                <div className="w-1/2 font-semibold">{label}</div>
                <div className="w-1/2">
                    {isEditing ? (
                        options ? (
                            <CustomSelect
                                options={options}
                                placeHolder={`Select company...`}
                                onChange={(e) => onEdit((field === "productType") ? e.label : e.value)}
                                isSearchable
                                value={value}
                            />
                        ) : (
                            <input
                                type={type}
                                className="border border-gray-200 px-2 py-1 rounded w-full"
                                value={value || (editing.show ? '' : 'N/A')}
                                onChange={(e) => onEdit(e.target.value)}
                                autoFocus
                            />
                        )
                    ) : (
                        <span className={`text-gray-700 ${route ? 'cursor-pointer hover:underline' : ''}`}
                            onClick={route ? handleClick : undefined}>
                            {value || (editing.show ? '' : 'N/A')}
                        </span>
                    )}
                </div>
            </div>
        );
    };

    const EditableFieldsList = ({
        editableData,
        onEditField,
        onSaveField,
        editing,
        toggleEditing,
    }) => {
        return (
            <div className="border border-blue-100 rounded w-full">
                {/* Column headers */}
                <div className="flex py-2 px-4 font-bold text-gray-800 bg-blue-100/75 text-sm">
                    <div className="w-1/2">Field</div>
                    <div className="w-1/2">Value</div>
                </div>


                {/* List of fields */}
                {[
                    { label: "Vin", value: getCaseInsensitive(editableData, "vin"), field: "vin" },
                    { label: "Reference", value: getCaseInsensitive(editableData, "reference"), field: "reference" },
                    {
                        label: "Owner", value: getCompanyNameById(companyData?.find(e => (getCaseInsensitive(e, "customer id").toString() === getCaseInsensitive(editableData, "owner").toString() || getCaseInsensitive(e, "id").toString() === getCaseInsensitive(editableData, "owner").toString()))?.["id"]), field: "owner", options: companyOptions(),
                        route: `/main/company/${companyData?.find(e => (getCaseInsensitive(e, "customer id").toString() === getCaseInsensitive(editableData, "owner").toString() || getCaseInsensitive(e, "id").toString() === getCaseInsensitive(editableData, "owner").toString()))?.["id"]}`
                    },
                    { label: "Type", value: getCaseInsensitive(editableData, "type"), field: "type" },
                    { label: "Category", value: getCaseInsensitive(editableData, "category"), field: "category" },
                    { label: "Brand", value: getCaseInsensitive(editableData, "brand"), field: "brand" },
                    { label: "Model", value: getCaseInsensitive(editableData, "model"), field: "model" },
                    { label: "Number Plate", value: getCaseInsensitive(editableData, "numberplate"), field: "numberplate" },
                    { label: "Country of origin", value: getCaseInsensitive(editableData, "numberPlateCountry"), field: "numberPlateCountry" },
                ].map((item, index) => (
                    <EditableField
                        key={item.field}
                        label={item.label}
                        value={item.value}
                        isEditing={editing.show}
                        onEdit={(value) => onEditField(item.field, value)}
                        field={item.field}
                        options={item.options}
                        backgroundColor={index % 2 === 0 ? 'bg-white' : 'bg-blue-100/20'}
                        route={item.route}
                    />
                ))}
            </div>
        );
    };

    const InfoSection = ({
        editableData,
        companyData,
        companyOptions,
        toggleEditing,
        editing,
        title
    }) => {
        const [editableVehicleData, setEditableVehicleData] = useState({ ...editableData });
        const [saving, setSaving] = useState({ info: false })

        // Handle input changes by updating editableEhuData state immutably
        const handleEditField = (field, value) => {
            setEditableVehicleData((prevState) => ({
                ...prevState,
                [field]: value,
            }));
        };

        const handleSaveField = async () => {
            setSaving((prevState) => ({
                ...prevState,
                info: true, // Set specific saving status to true
            }));
            try {
                await new Promise((resolve) => setTimeout(resolve, 300)); // Small delay to show "saving"
                await dataUpdateRequestHandler(editableVehicleData); // Actual save operation
            } finally {
                setSaving((prevState) => ({
                    ...prevState,
                    info: false, // Set specific saving status to true
                }));
                toggleEditing('show'); // Exit editing mode after saving
            }
        };
        return (
            <div className="w-full px-4">
                <div className="flex items-center justify-between border-b-2 border-gray-100 mt-2 mb-4">
                    <h3 className="font-semibold text-lg text-gray-800">{title}</h3>
                    {!editing.show ? (
                        <PencilSquareIcon
                            className="h-5 w-5 text-gray-600 hover:text-blue-400 cursor-pointer"
                            onClick={() => toggleEditing('show')}
                        />
                    ) : (
                        <div className="flex space-x-2 items-center">
                            {saving.info ? (
                                <span className="text-sm text-indigo-600">Saving changes...</span>
                            ) : (
                                <>
                                    <FontAwesomeIcon
                                        icon={faFloppyDisk}
                                        className="h-5 w-5 text-gray-600 hover:text-green-400 cursor-pointer"
                                        onClick={handleSaveField}
                                    />
                                    <FontAwesomeIcon
                                        icon={faRectangleXmark}
                                        className="h-5 w-5 text-gray-600 hover:text-red-400 cursor-pointer"
                                        onClick={() => toggleEditing('show')}
                                    />
                                </>
                            )}
                        </div>
                    )}
                </div>
                <EditableFieldsList
                    editableData={editableVehicleData}
                    onEditField={handleEditField}
                    onSaveField={handleSaveField}
                    editing={editing}
                    toggleEditing={toggleEditing}
                />
            </div>
        );
    };

    return (
        <>
            {!loading ?
                <div className="relative container mx-auto bg-white rounded-lg shadow-2xl min-h-[46.4rem]">
                    <div className="mb-1 sm:mb-4 justify-between w-full items-center">
                        <div>
                            <div className="mb-0 px-4 pt-4 border-0">
                                <div className="flex lg:flex-row flex-col">
                                    <div className="relative px-4 max-w-full">
                                        <h3 className="font-semibold text-lg text-gray-800">{getCaseInsensitive(vehicleData, "reference")}</h3>
                                    </div>
                                    <div className="relative px-4 max-w-full flex lg:flex-col text-sm lg:border-l-2">
                                        <span className="flex lg:mr-0 mr-1">Type:</span>
                                        <span className="flex text-indigo-600">{getCaseInsensitive(vehicleData, "type")}</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="rounded-t mb-0 pt-1 pb-4 px-4 border-0">
                                    <div className="relative px-4 max-w-full flex flex-row items-center">
                                        <IdentificationIcon className="h-5 w-5 text-gray-600" aria-hidden="true" />
                                        <span className="text-gray-500 px-2 text-sm">{id}</span>
                                    </div>
                                    <div className="relative px-4 max-w-full flex flex-row items-center">
                                        <FontAwesomeIcon
                                            icon={faBarcode}
                                            className="h-4 w-5 text-gray-500"
                                        />
                                        <span className="text-gray-500 px-2 text-sm">{getCaseInsensitive(vehicleData, "vin")}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="relative lg:flex mb-1 sm:mb-4">
                                <div className="flex flex-row mb-1 justify-between w-full lg:mr-2">
                                    <div className="mb-0 px-4 py-4 w-full">
                                        <InfoSection
                                            editableData={editableVehicleData}
                                            editing={editing}
                                            toggleEditing={toggleEditing}
                                            title="Vehicle Information"
                                        ></InfoSection>
                                    </div>
                                </div>
                                <div className="flex flex-row justify-between w-full p-4">
                                    <div className="mb-0 px-4 border-0 w-full">
                                        <div className="flex flex-wrap items-center">
                                            <div className="flex flex-col w-full">
                                                <div className="relative w-full max-w-full flex-grow flex-1 mt-2 mb-4 flex justify-between border-b-2 border-gray-100 items-center">
                                                    <h3 className="font-semibold text-lg text-gray-800">{getCompanyByCustomerId(companyData, getCaseInsensitive(vehicleData, "owner"))} Vehicles</h3>
                                                </div>
                                            </div>
                                            <div className='w-full border border-blue-100 rounded'>
                                                <div className="flex py-2 px-4 bg-blue-100/75 font-semibold">
                                                    <div className="flex-1 text-sm">Reference</div>
                                                    <div className="flex-1 text-sm">Number Plate</div>
                                                    <div className="flex-1 text-sm">Type</div>
                                                </div>
                                                <ul>
                                                    {
                                                        vehiclesData.map((vehicle, index) => {
                                                            // Determine the background color based on the index
                                                            const backgroundColor = index % 2 === 0 ? 'bg-white' : 'bg-blue-100/20';
                                                            return (
                                                                <li key={vehicle["id"]} className={`flex py-2 px-4 border-t border-blue-100 ${backgroundColor}`}>
                                                                    <div onClick={() => navigate(`/main/vehicle/${vehicle.id}`)} className="flex-1 text-sm hover:text-indigo-400 cursor-pointer font-semibold">   {getCaseInsensitive(vehicle, "reference")} </div>
                                                                    <div title={getCaseInsensitive(vehicle, "plateNumber")} className="flex-1 text-sm whitespace-nowrap overflow-hidden text-ellipsis">{getCaseInsensitive(vehicle, "plateNumber")}</div>
                                                                    <div title={getCaseInsensitive(vehicle, "type")} className="flex-1 text-sm whitespace-nowrap overflow-hidden text-ellipsis">{getCaseInsensitive(vehicle, "type")}</div>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-row justify-between w-full">
                                <div className="mb-0 px-4 border-0 w-full p-4">
                                    <div className="flex flex-wrap items-center px-4 mr-2">
                                        <div className="flex flex-col w-full">
                                            <div className="relative w-full max-w-full flex-grow flex-1 mt-2 mb-4 flex justify-between border-b-2 border-gray-100 items-center">
                                                <h3 className="font-semibold text-lg text-gray-800">Electronic Housing Unit</h3>
                                                {!showSelect ? (
                                                    <SquaresPlusIcon className="h-5 w-5 cursor-pointer text-gray-600 hover:text-green-400" onClick={() => setShowSelect(!showSelect)} />
                                                ) : (
                                                    <div className="flex space-x-2">
                                                        <FontAwesomeIcon
                                                            icon={faRectangleXmark}
                                                            className="h-5 w-5 text-gray-600 hover:text-red-400 cursor-pointer"
                                                            onClick={() => setShowSelect(!showSelect)}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div className={`w-full pb-2 ${showSelect ? "" : "hidden"}`}>
                                                <ElectronicHousingUnitSelect classname="w-full" required={true} onChange={(ehu) => addEhu(ehu)} />
                                            </div>
                                        </div>
                                        <div className='w-full border border-blue-100 rounded'>
                                            <div className="flex py-2 px-4 bg-blue-100/75 font-semibold">
                                                <div className="flex-1 text-sm">System</div>
                                                <div className="flex-1 text-sm">Type</div>
                                                <div className="flex-1 text-sm">Serial Number</div>
                                                <div className="flex-1 text-sm">Status</div>
                                                <div className="flex w-1/12 justify-center"></div>
                                            </div>
                                            <ul>
                                                {
                                                    vehicleEhuData.map((item, index) => {
                                                        // Determine the background color based on the index
                                                        const backgroundColor = index % 2 === 0 ? 'bg-white' : 'bg-blue-100/20';
                                                        return (
                                                            <li key={item["id"]} className={`flex py-2 px-4 border-t border-blue-100 ${backgroundColor}`}>
                                                                <div onClick={() => navigate(`/main/electronic-housing-unit/${item["id"]}`)} className="flex-1 text-sm hover:text-indigo-400 cursor-pointer font-semibold">{item?.["id"]}</div>

                                                                <div title={item["productType"]} className="flex-1 text-sm whitespace-nowrap overflow-hidden text-ellipsis">{item["productType"]}</div>
                                                                <div title={item["productCode"]} className="flex-1 text-sm whitespace-nowrap overflow-hidden text-ellipsis">{item["productCode"]}</div>
                                                                <div title={item["status"]} className="flex-1 text-sm whitespace-nowrap overflow-hidden text-ellipsis">{item["status"]}</div>
                                                                <div className="flex w-1/12 justify-end items-center">
                                                                    <MinusCircleIcon
                                                                        className="h-5 w-5 text-red-600 cursor-pointer hover:text-red-400"
                                                                        onClick={() => removeEhu(item["id"])}
                                                                    />
                                                                </div>
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-0 px-4 border-0 w-full p-4">
                                    <div className="flex flex-wrap items-center">
                                        <div className="flex flex-col w-full">
                                            <div className="relative w-full max-w-full flex-grow flex-1 mt-2 mb-4 flex justify-between border-b-2 border-gray-100 items-center">
                                                <h3 className="font-semibold text-lg text-gray-800">Parts</h3>
                                                {!showSelect2 ? (
                                                    <SquaresPlusIcon className="h-5 w-5 cursor-pointer text-gray-600 hover:text-green-400" onClick={() => setShowSelect2(!showSelect2)} />
                                                ) : (
                                                    <div className="flex space-x-2">

                                                        <FontAwesomeIcon
                                                            icon={faRectangleXmark}
                                                            className="h-5 w-5 text-gray-600 hover:text-red-400 cursor-pointer"
                                                            onClick={() => setShowSelect2(!showSelect2)}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div className={`w-full pb-2 ${showSelect2 ? "" : "hidden"}`}>
                                                <PartsSelect classname="w-full" required={true} onChange={(part) => addPart(part)} />
                                            </div>
                                            {partError && (
                                                <div className="w-full flex justify-center items-center mb-2">
                                                    <span className="text-red-600 bg-red-100 border border-red-300 rounded px-4 py-2 text-sm font-medium shadow-sm">
                                                        {partError.type} with serial number:{' '}
                                                        <span
                                                            onClick={() => navigate(`/main/part/${partError.partId}`)}
                                                            className="text-blue-600 underline cursor-pointer hover:text-blue-800"
                                                        >
                                                            {partError.serialNumber}
                                                        </span>{' '}
                                                        already has a connected vehicle, please disconnect this first.
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        <div className='w-full border border-blue-100 rounded'>
                                            <div className="flex py-2 px-4 bg-blue-100/75 font-semibold">
                                                <div className="flex-1 text-sm">Part</div>
                                                <div className="flex-1 text-sm">Type</div>
                                                <div className="flex-1 text-sm">Serial Number</div>
                                                <div className="flex w-1/12 justify-center"></div>
                                            </div>
                                            <ul>
                                                {
                                                    vehiclePartsData.map((part, index) => {
                                                        // Determine the background color based on the index
                                                        const backgroundColor = index % 2 === 0 ? 'bg-white' : 'bg-blue-100/20';
                                                        const spec = specData?.find(e => e.id === parseInt(part["partSpecificationsId"]));
                                                        return (
                                                            <li key={part["id"]} className={`flex py-2 px-4 border-t border-blue-100 ${backgroundColor}`}>
                                                                <div onClick={() => navigate(`/main/part/${part["id"]}`)} className="flex-1 text-sm hover:text-indigo-400 cursor-pointer font-semibold">{spec?.["partType"]}</div>
                                                                <div className="flex-1 text-sm flex flex-col">
                                                                    <span>{spec?.["details"][0]["value"]}</span>
                                                                    <span>{spec?.["details"][1]?.["value"]}</span>
                                                                </div>
                                                                <div title={part["serialNumber"]} className="flex-1 text-sm whitespace-nowrap overflow-hidden text-ellipsis">{part["serialNumber"]}</div>
                                                                <div className="flex w-1/12 justify-end items-center">
                                                                    <MinusCircleIcon
                                                                        className="h-5 w-5 text-red-600 cursor-pointer hover:text-red-400"
                                                                        onClick={() => removePart(part["id"])}
                                                                    />
                                                                </div>
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-row mb-1 justify-between w-full items-center lg:mr-2 pb-4">
                                <div className="mb-0 px-4 py-4 border-0 w-full">
                                    <div className="flex flex-wrap items-center">
                                        <div className="relative w-full px-4 max-w-full flex-grow flex-1"><h3
                                            className="font-semibold text-lg text-gray-800 border-b-2 border-gray-100 py-2">Remarks</h3>
                                        </div>
                                    </div>
                                    <RemarkTextArea
                                        required
                                        onChange={e => newRemarkHandler(e)}
                                        value={newRemark}
                                        confirm={() => newRemarkRequestHandler()}
                                        cancel={() => newRemarkCancelHandler()} />
                                    {reverseArray(vehicleData["remarks"]).map((remark, index) => {
                                        return (
                                            <div key={remark["Id"]} className="relative w-full px-4 py-4 max-w-full border-b border-gray-200">
                                                <div className="flex justify-between items-start">
                                                    <div className="w-full">
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center space-x-2">
                                                                <span className="text-indigo-600 font-medium">{remark["Name"]}</span>
                                                                <span className="text-gray-400 text-sm">{moment(remark["On"]).format("DD-MM-yyyy")}</span>
                                                            </div>
                                                            {/* Edit/Delete Buttons — only if not deleted */}
                                                            {remark.RemovedOn === "0001-01-01T00:00:00+00:00" && (
                                                                (remark["By"] === accountData["id"] || accountData.roles?.includes("administrator")) && (
                                                                    <div className="flex space-x-2">
                                                                        {remark["By"] === accountData["id"] && (
                                                                            <button
                                                                                onClick={() => handleRemarkEdit(remark["Id"], remark["Text"])}
                                                                                className="text-blue-500 hover:text-blue-700 text-sm"
                                                                            >
                                                                                Edit
                                                                            </button>
                                                                        )}
                                                                        {(accountData.roles?.includes("administrator") || remark["By"] === accountData["id"]) && (
                                                                            <button
                                                                                onClick={() => handleRemarkDelete(remark["Id"])}
                                                                                className="text-red-500 hover:text-red-700 text-sm"
                                                                            >
                                                                                Delete
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                        {/* Remark Text or Deleted Notice */}
                                                        <div className="text-sm mt-2 text-gray-600">
                                                            {remark.RemovedOn !== "0001-01-01T00:00:00+00:00" && remark.DeletedName ? (
                                                                <div className="italic text-red-500">
                                                                    This remark was deleted by {remark.DeletedName} on{" "}
                                                                    {moment(remark.RemovedOn).format("LLL")}
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {editRemark.id === remark["Id"] ? <RemarkTextArea
                                                                        required
                                                                        onChange={e => newRemarkHandler(e)}
                                                                        value={editRemark?.text}
                                                                        confirm={() => newRemarkRequestHandler()}
                                                                        cancel={() => newRemarkCancelHandler()} /> : <pre className="whitespace-pre-wrap break-words text-sm text-gray-600 font-sans">{remark["Text"]}</pre>}
                                                                    {/* Edited Info */}
                                                                    {remark.ModifiedOn !== "0001-01-01T00:00:00+00:00" && remark.EditedName && (
                                                                        <div className="text-xs text-gray-400 mt-1 italic">
                                                                            Edited by {remark.EditedName} on {moment(remark.ModifiedOn).format("LLL")}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : null}
        </>
    )
}